/**
 * Integrytas Group - Base App
 * Branding constants.
 *
 * APPLICATION_NAME is the plain-text product name, seeded in csm_system_parameters
 * under APP_NAME_PARAM_KEY so each product deployment can inherit its own name.
 *
 * BRANDING_SUFFIX ("by IntegrytasGroup") is stored Base64-encoded in
 * csm_system_parameters under BRANDING_SUFFIX_PARAM_KEY for soft tamper-resistance —
 * the value cannot be changed at the database level without knowing to re-encode it.
 *
 * Post-auth screens use use_branding() to read live values from the DB.
 * Pre-auth screens fall back to these hard-coded defaults.
 */

// csm_system_parameters internal_code keys
export const APP_NAME_PARAM_KEY       = 'INTEGRYTAS.APP.NAME';
export const BRANDING_SUFFIX_PARAM_KEY = 'INTEGRYTAS.APP.BRANDING_SUFFIX';

// Default product name for this deployment. Each derived app sets its own name
// via VITE_APP_NAME in .env.local (pre-auth fallback); post-auth, use_branding()
// overrides it from the INTEGRYTAS.APP.NAME system parameter. This keeps the app
// name a per-app CONFIG value — never a code edit — so upstream merges stay clean.
export const DEFAULT_APP_NAME =
  ((import.meta.env.VITE_APP_NAME as string | undefined) ?? '').trim() || 'APPLICATION';

// "by IntegrytasGroup" — Base64 encoded.
// atob('YnkgSW50ZWdyeXRhc0dyb3Vw') === 'by IntegrytasGroup'
const _ENCODED_BRANDING_SUFFIX = 'YnkgSW50ZWdyeXRhc0dyb3Vw';

export function decodeBrandingValue(encoded: string): string {
  try { return atob(encoded); } catch { return ''; }
}

export const APPLICATION_NAME = DEFAULT_APP_NAME;
export const BRANDING_SUFFIX  = decodeBrandingValue(_ENCODED_BRANDING_SUFFIX);
export const WATERMARK_TEXT   = `${APPLICATION_NAME} ${BRANDING_SUFFIX}`;
